import { CLASSES } from '../utils/constants';
import { toggleHtmlClass, injectGlobalStyle } from '../utils/domHelpers';

const ANIMATION_CSS =
  '*, *::before, *::after { animation-duration: 0s !important; animation-delay: 0s !important; }';

const TRANSITION_CSS =
  '*, *::before, *::after { transition-duration: 0s !important; transition-delay: 0s !important; }';

export function applyStopAnimations(enabled) {
  toggleHtmlClass(CLASSES.hideAnimations, enabled);
  if (enabled) {
    injectGlobalStyle(ANIMATION_CSS);
  }
}

export function applyReduceTransitions(enabled) {
  toggleHtmlClass(CLASSES.reduceTransitions, enabled);
  if (enabled) {
    injectGlobalStyle(TRANSITION_CSS);
  }
}

export function applyDisableAutoplay(enabled) {
  document.querySelectorAll('video, audio, iframe').forEach((el) => {
    if (enabled) {
      el.setAttribute('data-pb-a11y-autoplay-saved', el.autoplay ? 'true' : 'false');
      if (el.autoplay) {
        el.autoplay = false;
        if (typeof el.pause === 'function') el.pause();
      }
    } else {
      const saved = el.getAttribute('data-pb-a11y-autoplay-saved');
      if (saved === 'true') {
        el.autoplay = true;
        if (typeof el.play === 'function') el.play().catch(() => {});
      }
      el.removeAttribute('data-pb-a11y-autoplay-saved');
    }
  });
}
